import { RemoteGetPaginatedOrganizationTcesWaitingStudentSignature } from 'data/usecases';
import { makeApiUrlEntities } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetPaginatedOrganizationTcesWaitingStudentSignature =
  (): RemoteGetPaginatedOrganizationTcesWaitingStudentSignature => {
    return new RemoteGetPaginatedOrganizationTcesWaitingStudentSignature(
      makeApiUrlEntities(),
      makeAxiosHttpClient(),
    );
  };
